class DesignerElement extends HTMLElement {
    constructor(){
      super();
      this.groups    = this.querySelectorAll(".designers .container_designers .group")
      this.designers = this.querySelectorAll(".designers .designer");
      this.letters   = this.querySelectorAll(".letter");
      this.vendors   = this.querySelectorAll('[data-vendor]');
      this.listener();
      this.handleVisibility();
      this.calcMaxHeight(window.screen.width);
      this.groupVendors();
    }
  
    listener(){
      this.addEventListener("click", (e)=>{
        if(e.target.matches('.letter')){
          this.letterFilter(e.target);
        }
        if(!e.target.matches('.letter')){
          this.clearFilter();
        }
        this.querySelectorAll('a[href^="#"]').forEach(anchor => {
          if(e.target == anchor){
            e.preventDefault();
            this.smoothScroll(anchor);
          }
        });
      });
      window.addEventListener("resize", ()=>{
        this.calcMaxHeight(window.screen.width);
      })
    }

  
    calcMaxHeight(screenWidth) {
        const container = this.querySelector(".container_designers")
        if (this.designers.length <= 10 || screenWidth < 768) {
            container.style.maxHeight = 'none';
            return;
        }
    
        let numDesigners = this.designers.length;
        let totHeight = 0;
        this.designers.forEach(designer => totHeight += designer.clientHeight);
        const midHeight = totHeight / numDesigners;
        let designersPerColumn = numDesigners / 4;
        let nGroups = 0;
        let heightGroup = 0;
        
        this.groups.forEach(group => {
            if (group.classList.contains("visible")) {
                nGroups++;
            }
            heightGroup += group.clientHeight;
        });
        let groupsPerColumn = nGroups / 2;
        if ( screenWidth < 1024) {
            designersPerColumn = numDesigners / 2;
            groupsPerColumn = nGroups / 2;
        }
    
        let maxTotalHeight = (midHeight * designersPerColumn + groupsPerColumn * 20 + designersPerColumn * 8) + 150;

        container.style.maxHeight = maxTotalHeight + "px";
    }
    
    smoothScroll(anchor){
      this.querySelector(anchor.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    }
  
    handleVisibility(){
      this.groups.forEach((group)=>{
        if(group.querySelector(".designers_group").children.length > 0){
          group.classList.add("visible");
        }
        else{
          this.letters.forEach((filter_letter)=>{
            if(filter_letter.innerText == group.id){
              filter_letter.classList.add("hidden");
              group.remove();
            }
          })
        }
      })
    }
  
    letterFilter(active_letter){        
        this.letters.forEach(letter => {
            letter.classList.remove("tw-opacity-30");
            if (letter !== active_letter) {
                letter.classList.add("tw-opacity-30");
            }
        });

        this.designers.forEach(designer => {
            const isActive = designer.querySelector(".designer_link").dataset.letter === active_letter.innerText;
            designer.classList.toggle("tw-opacity-30", !isActive);
        });
    }
      
    clearFilter(){
      this.letters.forEach(letter =>{
        letter.classList.remove("tw-opacity-30");
      })
      this.designers.forEach(designer =>{
        designer.classList.remove("tw-opacity-30");
      })
    }

    groupVendors() {
        this.vendors.forEach(vendor => {
            const isExcludedFromGrouping = vendor.getAttribute('data-excluded-designer') === 'true';
            if (isExcludedFromGrouping) {
                vendor.classList.add("hidden");
            }
        });
    }
  }
  
customElements.define('designers-element', DesignerElement);